import { InputHTMLAttributes } from 'react';

/**
 * SearchInput — a --surface pill with a leading search icon and a borderless
 * input. Used atop dense lists (chat inbox, libraries).
 */
export interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchInput({ value, onChange, placeholder = 'Search', style, ...props }: SearchInputProps) {
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 9,
        background: 'var(--surface)', border: '1px solid var(--line)',
        borderRadius: 999, padding: '8px 14px',
        ...style,
      }}
    >
      <i className="ti ti-search" style={{ fontSize: 14, color: 'var(--text-dim)', flexShrink: 0 }} />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          flex: 1, minWidth: 0, background: 'transparent', border: 'none', outline: 'none',
          color: 'var(--text)', fontFamily: 'var(--font-sans)', fontSize: 12.5,
        }}
        {...props}
      />
    </div>
  );
}

export default SearchInput;
